import OrphanAssignmentItem from '../../../../Domain/OrphanAssignmentItem';
import TabOfDataTable from '../../../../Elements/DataTable/TabOfDataTable';
import OrphanedAssignmentService from '../../../../Services/OrphanedAssignmentService';
import React from 'react';
import OrphanedAssignmentSearchParams from './OrphanedAssignmentSearchParams';

export default class AssignmentListOrphanProjectAdmin extends React.Component {
  static defaultProps = {
    clientId: null,
  };

  constructor(props) {
    super(props);

    this.state = {
      searchItem: new OrphanedAssignmentSearchParams(),
    };

    this.state.searchItem.ClientNameOrId = this.props.clientId;

    this.startSearch = this.startSearch.bind(this);
  }

  startSearch(searchItem) {
    this.setState({
      searchItem: { ...searchItem, ClientNameOrId: this.props.clientId },
    });
  }

  render() {
    return (
      <div className='contentwrapper'>
        <TabOfDataTable
          type={OrphanAssignmentItem}
          serviceFunction={OrphanedAssignmentService.GetAssignmentListOrphanProject}
          convertDBItemsFunction={OrphanedAssignmentService.ConvertOrphanAssignmentDBItems}
          searchItem={this.state.searchItem}
          searchParamsType={OrphanedAssignmentSearchParams}
          showSearchStrip={true}
          clickOnStartSearch={this.startSearch}
          orderBy='CcCompanyName'
          errorCode='ALOPA26'
        />
      </div>
    );
  }
}
